export const ProfileActionsWidgetHideWidgetsButtonAction = {
  hide: 'hideWidgets',
  show: 'showWidgets',
}

export const PROFILE_ACTIONS_WIDGET_HIDE_WIDGETS_BUTTON_TOOLTIP_KEY = {
  [ProfileActionsWidgetHideWidgetsButtonAction.hide]:
    'Profile.ActionsWidgetHideWidgetsTooltipKey',
  [ProfileActionsWidgetHideWidgetsButtonAction.show]:
    'Profile.ActionsWidgetShowWidgetsTooltipKey',
}
